import { PAYWALL_TIMER_MINUTES } from '@/constants';

import { LimitedTimer } from '../../components/LimitedTimer';

import './Timer.scss';

export const OnboardingPaywallSectionTimer: React.FC = () => {
  return (
    <section className="timer">
      <LimitedTimer timeToExpire={PAYWALL_TIMER_MINUTES * 1000 * 60} />
    </section>
  );
};
